import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, CardContent, Typography, MenuItem, Table, TableBody, TableRow, TableCell, TableHead } from '@material-ui/core';
import ReactTable from "react-table";
import _ from 'lodash';
import * as TableActions from 'main/components/tableSort/store/actions';
import TableCellTooltip from '../../components/TableCellTooltip';

let moment = require('moment');

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    button: {
        width: '100%'
    }
});

class AuthActivityTab extends Component {

    constructor(props) {
        super(props);
    }

    getRoleColumn = (row) => {
        if (row.role_id === 1 || row.role_id === 2 || row.role_id === 4) {
            return row.RoleName
        }
        return row.RoleName + ' (' + row.CompanyName + ')'
    }

    render() {
        const { classes, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const table_name = this.constructor.name;

        const loginTable = this.props.currentAuth.roles.map(row => (
            <TableRow key={row.link_id + '-' + row.company_id}>
                <TableCell>{this.getRoleColumn(row)}</TableCell>
                <TableCell>{row.LastLogin || 'None'}</TableCell>
            </TableRow>
        ))

        return (
            <div>
                <div>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Role</TableCell>
                                <TableCell>Last Login</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loginTable}
                        </TableBody>
                    </Table>
                </div>
                <ReactTable
                    // style={{ position: 'absolute' }}
                    columns={[
                        {
                            Header: "Role",
                            accessor: "RoleName",
                            id: 'role',
                            width: 100
                        },
                        {
                            Header: "Action",
                            accessor: "ActionType",
                            id: 'action',
                            width: 100
                        },
                        {
                            Header: "Action Description",
                            Cell: row => (
                                <TableCellTooltip
                                    item={row.original.ActionDescription}
                                    chars={20}
                                />
                            )
                        },
                        {
                            Header: "ActionTime",
                            accessor: a => moment(a.ActionTime).format('YYYY-MM-DD HH:mm'),
                            id: 'time'
                        }
                    ]}
                    data={this.props.currentAuth.AuthActivityList}
                    defaultPageSize={25}
                    pageSize={table_page_size[table_name]}
                    className="-striped -highlight"
                    noDataText="No Actions Found"
                    defaultSorted={table_sort[table_name]}
                    onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                    filterable={true}
                    defaultFiltered={table_filter[table_name]}
                    onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                    onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                />
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setTableSort: TableActions.setTableSort,
        setTableFilter: TableActions.setTableFilter,
        setTablePageSize: TableActions.setTablePageSize,
    }, dispatch);
}

function mapStateToProps({ auth, tableSort }) {
    return {
        auth,
        table_sort: tableSort.table_sort,
        table_filter: tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded: tableSort.is_loaded,
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthActivityTab)));


// WEBPACK FOOTER //
// src/main/content/auth/AuthActivityTab.js